import React, { useRef } from 'react';
import { normalizeRichText } from '../../../Utils/stripHtml';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './RichTextEditor.scss';

// Pasting from Word/Google Docs often carries non-breaking spaces ( ) in
// place of regular spaces. Left alone, a whole paragraph becomes one
// unbreakable "word" that blows out any layout it's dropped into (grids,
// flex columns, etc.) instead of wrapping normally — so normalize on paste.
const stripNonBreakingSpaces = (node, delta) => {
  delta.ops.forEach((op) => {
    if (typeof op.insert === 'string') {
      op.insert = op.insert.replace(/ /g, ' ');
    }
  });
  return delta;
};

const MODULES = {
  toolbar: [
    [{ header: [false, 2, 3, 4] }],
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link'],
    ['clean'],
  ],
  clipboard: {
    matchers: [[Node.TEXT_NODE, stripNonBreakingSpaces]],
  },
};

const FORMATS = ['header', 'bold', 'italic', 'underline', 'list', 'link'];

// Quill 2's getSemanticHTML() emits every space as &nbsp;, which renders as
// one unbreakable line on the site. Save regular spaces instead, but hand the
// editor back its own raw HTML so it doesn't reset (and lose the cursor).
const RichTextEditor = ({ value, onChange, placeholder }) => {
  const last = useRef({ raw: '', clean: '' });

  const handleChange = (html) => {
    const clean = normalizeRichText(html);
    last.current = { raw: html, clean };
    onChange(clean);
  };

  const editorValue = value && value === last.current.clean ? last.current.raw : value || '';

  return (
    <ReactQuill
      theme="snow"
      value={editorValue}
      onChange={handleChange}
      modules={MODULES}
      formats={FORMATS}
      placeholder={placeholder}
    />
  );
};

export default RichTextEditor;
